
import React from 'react';
import { SCHEDULE } from '../constants';

export const Schedule: React.FC = () => {
  return (
    <div className="py-24 max-w-3xl mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="font-serif-display text-4xl md:text-5xl mb-4 text-black">Wedding Day</h2>
        <p className="text-sm tracking-[0.3em] text-[#8E806A] font-medium uppercase opacity-70">The Schedule</p>
      </div>

      <div className="space-y-10">
        {SCHEDULE.map((item) => (
          <div key={item.time} className="text-center group">
            <div className="flex flex-col items-center">
              <span className="text-[#A89A82] font-bold tracking-[0.3em] text-sm mb-2 drop-shadow-sm">
                {item.time}
              </span>
              <h4 className="text-2xl md:text-3xl font-serif-display text-black mb-2 group-hover:text-black/70 transition-colors">
                {item.event}
              </h4>
              <p className="text-gray-500 font-light max-w-md leading-normal">
                {item.description}
              </p>
              <div className="w-8 h-px bg-[#F5F2ED] mt-10 group-last:hidden" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
